import { render, staticRenderFns } from "./collageGoodsList.vue?vue&type=template&id=b24b03d2&scoped=true&"
import script from "./collageGoodsList.vue?vue&type=script&lang=js&"
export * from "./collageGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./collageGoodsList.vue?vue&type=style&index=0&id=b24b03d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24b03d2",
  null
  
)

export default component.exports